<template>
  <div class="page-spot">
    <v-container class="section">
      <h1 class="ttl-lg--center">
        <span class="ttl-lg__text"> {{ $t('menu.spot_status') }} </span>
      </h1>
      <v-row>
        <v-col cols="12">
          <v-row
            ><!-- タブ -->
            <v-col cols="12" class="nav-facilityCategoryWrap">
              <v-tabs
                v-model="spot_category_id"
                grow
                show-arrows
                hide-slider
                prev-icon=""
                next-icon=""
                height="57px"
                active-class="is-active"
                class="nav-facilityCategory"
                @change="changeSpotCategoryID"
              >
                <v-tab key="0" class="nav-facilityCategory__item is-all" href="#0"
                  ><span>{{ $t('page.spot_status.all') }}</span></v-tab
                >
                <v-tab key="7" class="nav-facilityCategory__item is-like" href="#7"
                  ><img class="nav-facilityCategory__icon" src="/static/facility-status/icon_like.svg" alt="" /><span>{{
                    $t('page.spot_status.favorite')
                  }}</span></v-tab
                >
                <v-tab key="1" class="nav-facilityCategory__item is-restaurant" href="#1"
                  ><img class="nav-facilityCategory__icon" src="/static/facility-status/icon_eat.svg" alt="" /><span>{{
                    $t('model.spot.spot_category_id_1')
                  }}</span></v-tab
                >
                <v-tab key="2" class="nav-facilityCategory__item is-play" href="#2"
                  ><img
                    class="nav-facilityCategory__icon"
                    src="/static/facility-status/icon_balloon.svg"
                    alt=""
                  /><span>{{ $t('model.spot.spot_category_id_2') }}</span></v-tab
                >
                <v-tab key="3" class="nav-facilityCategory__item is-transportation" href="#3"
                  ><img class="nav-facilityCategory__icon" src="/static/facility-status/icon_car.svg" alt="" /><span>{{
                    $t('model.spot.spot_category_id_3')
                  }}</span></v-tab
                >
                <v-tab key="4" class="nav-facilityCategory__item is-shopping" href="#4"
                  ><img class="nav-facilityCategory__icon" src="/static/facility-status/icon_cart.svg" alt="" /><span>{{
                    $t('model.spot.spot_category_id_4')
                  }}</span></v-tab
                >
                <v-tab key="5" class="nav-facilityCategory__item is-living" href="#5"
                  ><img
                    class="nav-facilityCategory__icon"
                    src="/static/facility-status/icon_building.svg"
                    alt=""
                  /><span>{{ $t('model.spot.spot_category_id_5') }}</span></v-tab
                >
                <v-tab key="6" class="nav-facilityCategory__item is-michinoeki" href="#6"
                  ><img class="nav-facilityCategory__icon" src="/static/facility-status/icon_cow.svg" alt="" /><span>{{
                    $t('model.spot.spot_category_id_6')
                  }}</span></v-tab
                >
              </v-tabs>
            </v-col>
            <v-col cols="pa-2 12" style="padding-bottom: 0px">
              <v-checkbox
                v-model="filter.is_open"
                :label="$t('page.spot_status.display_only_open_spots')"
                class="input-checkbox"
                @change="loadSpots(0)"
              />
            </v-col>
          </v-row>
          <v-row
            ><!-- 施設一覧 -->
            <v-col v-for="(spot, index) in spots" :key="'spot-' + index" xl="6" lg="6" md="6" cols="12" class="pa-2">
              <div class="card-facilityStatus">
                <div class="card-facilityStatus__container">
                  <div v-if="spot.comment_text !== null || spot.is_owner" class="card-facilityStatus__fukidashi">
                    <template v-if="editingSpotID === spot.id">
                      <v-form ref="form" v-model="valid" @submit.prevent>
                        <v-text-field
                          v-model="params.comment_text"
                          class="input-text required"
                          :counter="128"
                          required
                          outlined
                          :rules="[rules.required, rules.maxlength(128)]"
                        ></v-text-field>
                      </v-form>
                    </template>
                    <template v-else>{{ spot.comment_text }}</template>
                    <div v-if="spot.is_owner">
                      <template v-if="editingSpotID === spot.id">
                        <v-tooltip bottom>
                          <template #activator="{ on }">
                            <v-btn icon color="primary" v-on="on" @click="updateSpotComment()"
                              ><v-icon>check</v-icon></v-btn
                            >
                          </template>
                          <span>{{ $t('send') }}</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                          <template #activator="{ on }">
                            <v-btn icon color="red" v-on="on" @click="cancelEditing()"><v-icon>cancel</v-icon></v-btn>
                          </template>
                          <span>{{ $t('cancel') }}</span>
                        </v-tooltip>
                      </template>
                      <v-tooltip v-else bottom>
                        <template #activator="{ on }">
                          <v-btn icon color="primary" v-on="on" @click="startEditing(index)"
                            ><v-icon>edit</v-icon></v-btn
                          >
                        </template>
                        <span>{{ $t('edit') }}</span>
                      </v-tooltip>
                      <v-tooltip v-if="spot.comment_text !== null && editingSpotID === null" bottom>
                        <template #activator="{ on }">
                          <v-btn
                            v-if="spot.is_owner && spot.comment_text !== null"
                            icon
                            color="red"
                            v-on="on"
                            @click="deleteSpotComment(spot.id)"
                            ><v-icon>delete</v-icon></v-btn
                          >
                        </template>
                        <span>{{ $t('delete') }}</span>
                      </v-tooltip>
                    </div>
                  </div>
                  <div class="card-facilityStatus__data">
                    <div class="card-facilityStatus__title">
                      {{ $store.getters.getLocale == 'en' ? spot.spot_name_en : spot.spot_name }}
                    </div>
                    <div class="card-facilityStatus__category">
                      <span class="tag-facilityCategory" :class="categoryMap[spot.spot_category_id].class">
                        <img
                          class="tag-facilityCategory__icon"
                          :src="'/static/facility-status/icon_' + categoryMap[spot.spot_category_id].icon + '.svg'"
                          alt=""
                        />
                        <span>{{ $t('model.spot.spot_category_id_' + spot.spot_category_id) }}</span>
                        <span>│</span>
                        <span>{{ $store.getters.getLocale == 'en' ? spot.spot_type_en : spot.spot_type }}</span>
                      </span>
                    </div>
                  </div>
                  <div class="card-facilityStatus__buttons">
                    <v-btn
                      depressed
                      color="transparent"
                      class="btn-like"
                      :class="spot.is_favorite ? ['is-active'] : []"
                      @click="toggleFavorite(index)"
                    >
                      <svg
                        class="btn-like__icon"
                        width="24"
                        height="25"
                        viewBox="0 0 24 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <mask
                          id="mask0_1199_51521"
                          style="mask-type: alpha"
                          maskUnits="userSpaceOnUse"
                          x="0"
                          y="0"
                          width="24"
                          height="25"
                        >
                          <rect y="0.19043" width="24" height="24" fill="#D9D9D9" />
                        </mask>
                        <g mask="url(#mask0_1199_51521)">
                          <path
                            class="heart"
                            d="M11.63 20.9228L12 21.2591L12.37 20.9228L13.4679 19.9246C13.4683 19.9243 13.4687 19.924 13.469 19.9236C15.1394 18.4203 16.5217 17.122 17.6139 16.0297C18.7081 14.9356 19.5855 13.953 20.2395 13.0834C20.8928 12.2156 21.3675 11.4003 21.6422 10.6399C21.9133 9.89012 22.05 9.12291 22.05 8.34082C22.05 6.78559 21.5178 5.45577 20.4509 4.38891C19.3846 3.32264 18.0551 2.79082 16.5 2.79082C15.5431 2.79082 14.6312 3.01697 13.7709 3.46502L13.7706 3.46519C13.106 3.81192 12.5158 4.27413 12 4.84662C11.4842 4.27413 10.894 3.81192 10.2294 3.46519L10.2291 3.46502C9.36884 3.01697 8.45687 2.79082 7.5 2.79082C5.94488 2.79082 4.61537 3.32264 3.54909 4.38891C2.48223 5.45577 1.95 6.78559 1.95 8.34082C1.95 9.12291 2.08666 9.89012 2.35778 10.6399C2.63253 11.4003 3.1072 12.2156 3.76046 13.0834C4.41451 13.953 5.29193 14.9356 6.38609 16.0297C7.47833 17.122 8.86058 18.4203 10.531 19.9236C10.5313 19.924 10.5317 19.9243 10.5321 19.9246L11.63 20.9228Z"
                            fill=""
                            stroke="#949497"
                            stroke-width="1.5"
                          />
                        </g>
                      </svg>
                    </v-btn>

                    <v-dialog scrollable max-width="960px">
                      <template #activator="{ on, attrs }">
                        <v-btn class="btn-detail" depressed color="transparent" v-bind="attrs" v-on="on">
                          <img class="btn-detail__icon" src="/static/icon/icon_info_kgreen600.svg" alt="" />
                          <span class="btn-detail__text">{{ $t('detail') }}</span>
                        </v-btn>
                      </template>
                      <template #default="dialog">
                        <v-card class="modal-facility">
                          <v-card-text class="modal-facility__contents">
                            <div class="modal-facility__title">
                              <span class="ttl-xs__text">{{
                                $store.getters.getLocale == 'en' ? spot.spot_name_en : spot.spot_name
                              }}</span>
                            </div>
                            <div v-if="spot.comment_text !== null" class="modal-facility__fukidashi">
                              {{ spot.comment_text }}
                            </div>
                            <v-layout v-if="spot.spot_image1 !== null" justify-center
                              ><img
                                class="modal-facility__image"
                                :src="spot.spot_image1"
                                :alt="
                                  ($store.getters.getLocale == 'en' ? spot.spot_name_en : spot.spot_name) + 'の外観'
                                "
                            /></v-layout>
                            <div>
                              <dl v-if="spot.zipcode !== ''" class="lst-border">
                                <dt class="lst-border__title lst-border__title--sm">
                                  <img class="lst-border__icon" src="/static/icon/icon_location_grey600.svg" alt="" />
                                  {{ $t('model.spot.address') }}
                                </dt>
                                <dd class="lst-border__content">
                                  〒{{ spot.zipcode }} {{ spot.prefecture }}{{ spot.address1 }}{{ spot.address2 }}
                                  {{ spot.address3 }}
                                </dd>
                              </dl>
                              <dl v-if="spot.tel !== ''" class="lst-border">
                                <dt class="lst-border__title lst-border__title--sm">
                                  <img class="lst-border__icon" src="/static/icon/icon_phone_grey600.svg" alt="" />
                                  {{ $t('model.spot.tel') }}
                                </dt>
                                <dd class="lst-border__content">
                                  <a :href="'tel:' + spot.tel">{{ spot.tel }}</a>
                                </dd>
                              </dl>
                              <dl v-if="spot.is_open || !spot.is_holiday" class="lst-border">
                                <dt class="lst-border__title lst-border__title--sm">
                                  <img class="lst-border__icon" src="/static/icon/icon_watch_grey600.svg" alt="" />
                                  {{ $t('model.spot_status.business_hours') }}
                                </dt>
                                <dd class="lst-border__content">
                                  {{ spot.opened_at === null ? '' : toHHMM(spot.opened_at) }}
                                  <template v-if="spot.opened_at !== null || spot.closed_at !== null">～</template>
                                  {{ spot.closed_at === null ? '' : toHHMM(spot.closed_at, spot.opened_at) }}
                                  <template v-if="spot.reopened_at !== null || spot.reclosed_at !== null">
                                    /
                                    {{ spot.reopened_at === null ? '' : toHHMM(spot.reopened_at, spot.opened_at) }}
                                    ～
                                    {{ spot.reclosed_at === null ? '' : toHHMM(spot.reclosed_at, spot.opened_at) }}
                                  </template>
                                </dd>
                              </dl>
                              <dl v-if="spot.closing_days_text !== ''" class="lst-border">
                                <dt class="lst-border__title lst-border__title--sm">
                                  <img class="lst-border__icon" src="/static/icon/icon_calendar_grey600.svg" alt="" />
                                  {{ $t('model.spot.closing_days_text') }}
                                </dt>
                                <dd class="lst-border__content">{{ spot.closing_days_text }}</dd>
                              </dl>
                              <dl v-if="spot.payment_methods !== ''" class="lst-border">
                                <dt class="lst-border__title lst-border__title--sm">
                                  <img class="lst-border__icon" src="/static/icon/icon_money_grey600.svg" alt="" />
                                  {{ $t('model.spot.payment_methods') }}
                                </dt>
                                <dd class="lst-border__content">{{ spot.payment_methods }}</dd>
                              </dl>
                              <dl v-if="spot.url" class="lst-border">
                                <dt class="lst-border__title lst-border__title--sm">
                                  <img
                                    class="lst-border__icon"
                                    src="/static/icon/icon_personal_computer_grey600.svg"
                                    alt=""
                                  />
                                  {{ $t('model.spot.url') }}
                                </dt>
                                <dd class="lst-border__content">
                                  <a class="link-normal" target="_blank" :href="spot.url"
                                    >{{ spot.url
                                    }}<img
                                      class="link-normal__icon"
                                      src="/static/icon/icon_new_window_kgreen600.svg"
                                      alt=""
                                  /></a>
                                </dd>
                              </dl>
                            </div>
                            <p v-if="spot.other_information !== ''" class="modal-facility__memo caption-md">
                              {{ spot.other_information }}
                            </p>
                          </v-card-text>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="transparent" class="btn-tertiary--sm" @click="dialog.value = false">
                              <img class="btn-tertiary__icon" src="/static/icon/icon_close_kgreen600.svg" alt="" />
                              <span class="btn-tertiary__text">{{ $t('close') }}</span>
                            </v-btn>
                            <v-spacer></v-spacer>
                          </v-card-actions>
                        </v-card>
                      </template>
                    </v-dialog>
                  </div>
                  <div v-if="spot.is_open || !spot.is_holiday" class="card-facilityStatus__schedule">
                    <dl class="lst-table">
                      <dt class="lst-table__title lst-table__title--sm">
                        <img class="lst-table__icon" src="/static/icon/icon_watch_grey600.svg" alt="" />
                        {{ $t('model.spot_status.business_hours') }}
                      </dt>
                      <dd class="lst-table__content">
                        {{ spot.opened_at === null ? '' : toHHMM(spot.opened_at) }}〜{{
                          spot.closed_at === null ? '' : toHHMM(spot.closed_at, spot.opened_at)
                        }}
                        <template v-if="spot.reopened_at !== null || spot.reclosed_at !== null">
                          /
                          {{ spot.reopened_at === null ? '' : toHHMM(spot.reopened_at, spot.opened_at) }}〜{{
                            spot.reclosed_at === null ? '' : toHHMM(spot.reclosed_at, spot.opened_at)
                          }}
                        </template>
                      </dd>
                    </dl>
                  </div>
                  <div class="card-facilityStatus__occupancy">
                    <!-- 混雑状況なしの場合 -->
                    <div
                      v-if="spot.occupancy === null"
                      class="box-occupancy"
                      :class="[spot.is_open ? 'is-open' : 'is-closed']"
                    >
                      <v-layout align-center justify-center>
                        <span class="box-occupancy__status is-lg">{{
                          $t(
                            spot.is_open
                              ? 'model.spot_status.is_open_1'
                              : ('model.spot_status.is_' + (spot.is_holiday ? 'holiday_1' : 'open_0'))
                          )
                        }}</span>
                      </v-layout>
                    </div>
                    <!-- 空きなしの場合 -->
                    <div v-else-if="spot.occupancy >= spot.high_threshold" class="box-occupancy is-full">
                      <v-layout align-center justify-center>
                        <img class="box-occupancy__icon" src="/static/facility-status/img_occupancy_full.svg" alt="" />
                        <span class="box-occupancy__label">{{ spot.full_label }}</span>
                        <v-spacer></v-spacer>
                        <span class="box-occupancy__status">{{
                          $t(
                            spot.is_holiday
                              ? 'model.spot_status.is_holiday_1'
                              : 'model.spot_status.is_open_' + (spot.is_open ? 1 : 0),
                          )
                        }}</span>
                      </v-layout>
                    </div>
                    <!-- やや混雑の場合 -->
                    <div v-else-if="spot.occupancy >= spot.low_threshold" class="box-occupancy is-medium">
                      <v-layout align-center justify-center>
                        <img
                          class="box-occupancy__icon"
                          src="/static/facility-status/img_occupancy_medium.svg"
                          alt=""
                        />
                        <span class="box-occupancy__label">{{ spot.medium_label }}</span>
                        <v-spacer></v-spacer>
                        <span class="box-occupancy__status">{{
                          $t(
                            spot.is_holiday
                              ? 'model.spot_status.is_holiday_1'
                              : 'model.spot_status.is_open_' + (spot.is_open ? 1 : 0),
                          )
                        }}</span>
                      </v-layout>
                    </div>
                    <!-- 空きありの場合 -->
                    <div v-else class="box-occupancy is-low">
                      <v-layout align-center justify-center>
                        <img class="box-occupancy__icon" src="/static/facility-status/img_occupancy_low.svg" alt="" />
                        <span class="box-occupancy__label">{{ spot.empty_label }}</span>
                        <v-spacer></v-spacer>
                        <span class="box-occupancy__status">{{
                          $t(
                            spot.is_holiday
                              ? 'model.spot_status.is_holiday_1'
                              : 'model.spot_status.is_open_' + (spot.is_open ? 1 : 0),
                          )
                        }}</span>
                      </v-layout>
                    </div>
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
          <div v-if="offset < total" class="btn-wrap--center">
            <v-btn class="btn-tertiary" color="transparent" :loading="loading" @click="loadSpots()">
              <img class="btn-tertiary__icon" src="/static/icon/icon_add_kgreen600.svg" alt="" />
              <span class="btn-tertiary__text">{{ $t('page.spot_status.more_spots') }}</span>
            </v-btn>
          </div>
          <!-- もっと見るボタン -->
        </v-col>
        <v-dialog v-model="viewingMap" scrollable max-width="960px">
          <template #activator="{ on, attrs }">
            <v-btn fixed bottom v-bind="attrs" color="primary" class="btn-primary btn-map" v-on="on">
              <img class="btn-primary__icon" src="/static/icon/icon_map_white.svg" alt="" />
              <span class="btn-primary__text">{{ $t('page.spot_status.view_map') }}</span> </v-btn
            ><!-- 地図で見るボタン -->
          </template>
          <v-card class="modal-facility">
            <v-card-text class="modal-facility__contents" style="padding: 0px !important">
              <GmapMap
                :center="spotCenter"
                :zoom="16"
                map-type-id="roadmap"
                :options="{ styles: [{ featureType: 'all', elementType: 'labels', stylers: [{ visibility: 'off' }] }] }"
                :style="
                  $route.query.map === 'spot'
                    ? { position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', 'z-index': 1000 }
                    : { width: '100%', height: '800px' }
                "
              >
                <template v-for="(spot, spot_index) in spots">
                  <GmapMarker
                    :key="'spot-' + spot_index"
                    :position="spot"
                    :icon="{
                      url: spot.is_open
                        ? spot.occupancy >= spot.high_threshold
                          ? spot.full_icon
                          : spot.occupancy >= spot.low_threshold
                            ? spot.medium_icon
                            : spot.empty_icon
                        : spot.closed_icon,
                      labelOrigin: { x: 0, y: spot.id == 9 ? 40 : -10 },
                    }"
                    :label="{
                      color: spot.is_open
                        ? spot.occupancy >= spot.high_threshold
                          ? 'red'
                          : spot.occupancy >= spot.low_threshold
                            ? '#880'
                            : 'blue'
                        : 'gray',
                      text:
                        ($store.getters.getLocale == 'en' ? spot.short_name_en : spot.short_name) +
                        (spot.is_open === null
                          ? ''
                          : ' ' +
                            $t(
                              spot.is_holiday
                                ? 'model.spot_status.is_holiday_1'
                                : 'model.spot_status.is_open_' + (spot.is_open ? 1 : 0),
                            )) +
                        (!spot.is_open || spot.occupancy === null
                          ? ''
                          : ' ' +
                            (spot.occupancy >= spot.high_threshold
                              ? spot.full_label
                              : spot.occupancy >= spot.low_threshold
                                ? spot.medium_label
                                : spot.empty_label)),
                      className: 'map-icon-label',
                    }"
                    color="#f00"
                    @click="openedSpot = spot_index"
                  >
                    <GmapInfoWindow
                      :opened="spot_index === openedSpot"
                      :closeclick="true"
                      @closeclick="openedSpot = null"
                    >
                      <div>
                        <div>
                          <a v-if="spot.url" target="_blank" :href="spot.url">
                            {{ $store.getters.getLocale == 'en' ? spot.spot_name_en : spot.spot_name }}
                          </a>
                          <template v-else>
                            {{ $store.getters.getLocale == 'en' ? spot.spot_name_en : spot.spot_name }}
                          </template>
                        </div>
                        <div>{{ $store.getters.getLocale == 'en' ? spot.spot_type_en : spot.spot_type }}</div>
                        <div v-if="spot.opened_at !== null && spot.closed_at !== null">
                          {{ $t('model.spot_status.opened_at') }}:
                          {{
                            spot.opened_at
                              .replace(/-/g, '/')
                              .replace('T', ' ')
                              .replace(/:[0-9]{2}$/, '')
                          }}
                          <br />{{ $t('model.spot_status.closed_at') }}:
                          {{
                            spot.closed_at
                              .replace(/-/g, '/')
                              .replace('T', ' ')
                              .replace(/:[0-9]{2}$/, '')
                          }}
                        </div>
                        <div v-if="spot.place_id !== ''">
                          <a
                            :href="
                              'https://www.google.co.jp/maps/search/?api=1&query=' +
                              encodeURI(spotspot_name) +
                              '&query_place_id=' +
                              spot.place_id
                            "
                            target="_blank"
                            >{{ $t('page.service.to_google_maps') }}</a
                          >
                        </div>
                      </div>
                    </GmapInfoWindow>
                  </GmapMarker>
                </template>
              </GmapMap>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="transparent" class="btn-tertiary--sm" @click="viewingMap = false">
                <img class="btn-tertiary__icon" src="/static/icon/icon_close_kgreen600.svg" alt="" />
                <span class="btn-tertiary__text">{{ $t('close') }}</span>
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- 地図 -->
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Validation from '@/mixins/Validation'
import * as VueGoogleMaps from 'vue2-google-maps'
import { gmapApi } from 'vue2-google-maps'
import Vue from 'vue'
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyA1AxnW1-eu7el2cA5rFBa-v7Ui5XJ_oEI',
    libraries: 'places',
    region: 'JP',
    language: 'ja',
  },
})

export default {
  mixins: [Validation],

  data() {
    return {
      loading: false,
      valid: false,
      editingSpotID: null,
      spot_category_id: '0',
      offset: 0,
      total: 0,
      spots: [],
      spotCenter: { lat: 43.230751, lng: 143.293367 },
      openedSpot: null,
      viewingMap: false,

      categoryMap: {
        1: { class: 'is-restaurant', icon: 'eat' },
        2: { class: 'is-play', icon: 'balloon' },
        3: { class: 'is-transportation', icon: 'car' },
        4: { class: 'is-shopping', icon: 'cart' },
        5: { class: 'is-living', icon: 'building' },
        6: { class: 'is-michinoeki', icon: 'cow' },
      },

      filter: {
        is_open: true,
      },

      params: {
        comment_text: '',
      },
    }
  },

  computed: {
    google: gmapApi,
  },

  watch: {
    viewingMap() {
      if (this.viewingMap && this.offset < Math.min(600, this.total)) {
        this.loadSpots(this.offset, Math.min(600, this.total) - this.offset)
      }
    },
  },

  created() {
    if (['1', '2', '3', '4', '5', '6', '7'].includes(this.$route.query.spot_category_id)) {
      this.spot_category_id = this.$route.query.spot_category_id
    }
    if (this.$route.query.map === 'spot') {
      document.querySelector('body').classList.add('fullscreen')
      document.getElementsByTagName('html')[0].style.setProperty('overflow', 'hidden')
      this.viewingMap = true
    }
    this.loadSpots()
  },

  destroyed() {
    if (this.$route.query.map === 'spot') {
      document.querySelector('body').classList.remove('fullscreen')
      document.getElementsByTagName('html')[0].style.setProperty('overflow', 'auto')
    }
  },

  methods: {
    /**
     * 施設情報を読み込む。
     */
    async loadSpots(offset = null, limit = 12) {
      if (!this.loading) {
        if (offset !== null) {
          this.offset = offset
        }
        this.loading = true
        const res = await this.$axios.post('/api/spot/search', {
          spot_category_id: ['1', '2', '3', '4', '5', '6'].includes(this.spot_category_id)
            ? this.spot_category_id
            : null,
          'spot_category_id:min': 1,
          is_open: this.filter.is_open ? true : null,
          //is_holiday: this.filter.is_open ? false : null,
          is_favorite: this.spot_category_id == 7 ? true : null,
          sort: '+sort_order +spot_type',
          offset: this.offset,
          limit: limit,
        })
        if (res.data) {
          this.spots = this.offset === 0 ? res.data.items : this.spots.concat(res.data.items)
          this.total = res.data.total
          this.offset += limit
          let maxLat = -90
          let maxLng = -180
          let minLat = 90
          let minLng = 180
          res.data.items.forEach((item) => {
            maxLat = item.lat > maxLat ? item.lat : maxLat
            maxLng = item.lng > maxLng ? item.lng : maxLng
            minLat = item.lat < minLat ? item.lat : minLat
            minLng = item.lng < minLng ? item.lng : minLng
          })
          if (maxLat !== -90 && minLat !== 90) {
            //this.spotCenter.lat = (maxLat + minLat) / 2
            //this.spotCenter.lng = (maxLng + minLng) / 2
          }
        }
        this.loading = false
      }
    },

    async addFavorite(index) {
      this.loading = true
      const res = await this.$axios.put('/api/member/favorite/spot/' + this.spots[index].id, {}, { ignores500: true })
      if (res.data) {
        if (res.data.result) {
          this.spots[index].is_favorite = true
        }
      }
      this.loading = false
    },

    async removeFavorite(index) {
      this.loading = true
      const res = await this.$axios.delete('/api/member/favorite/spot/' + this.spots[index].id, {
        ignores404: true,
        ignores500: true,
      })
      if (res.data) {
        if (res.data.result) {
          this.spots[index].is_favorite = false
        }
      }
      this.loading = false
    },

    async updateSpotComment() {
      if (!this.loading && this.$refs.form[0].validate()) {
        this.loading = true
        const res = await this.$axios.put('/api/spot/comment/' + this.editingSpotID, this.params, { ignores500: true })
        if (res.data) {
          if (res.data.result) {
            this.spots.some((spot) => {
              if (spot.id === this.editingSpotID) {
                spot.comment_text = this.params.comment_text
                return true
              }
              return false
            })
            this.editingSpotID = null
          }
        }
        this.loading = false
      }
    },

    async deleteSpotComment(spot_id) {
      if (!this.loading && confirm(this.$t('delete_confirm'))) {
        this.loading = true
        const res = await this.$axios.delete('/api/spot/comment/' + spot_id, { ignores404: true, ignores500: true })
        if (res.data) {
          if (res.data.result) {
            this.spots.some((spot) => {
              if (spot.id === spot_id) {
                spot.comment_text = null
                return true
              }
              return false
            })
          }
        }
        this.loading = false
      }
    },

    toggleFavorite(index) {
      if (this.spots[index].is_favorite) {
        this.removeFavorite(index)
      } else {
        this.addFavorite(index)
      }
    },

    changeSpotCategoryID() {
      this.loadSpots(0)
    },

    startEditing(index) {
      this.params.comment_text = this.spots[index].comment_text
      this.editingSpotID = this.spots[index].id
    },

    cancelEditing() {
      this.editingSpotID = null
    },

    toHHMM(date, basedate = null) {
      return (
        String(
          (basedate !== null && basedate.substring(0, 10) != date.substring(0, 10) ? 24 : 0) +
            Number(date.substring(11, 13)),
        ) +
        ':' +
        ('00' + date.substring(14, 16)).slice(-2)
      )
    },
  },
}
</script>
<style scoped type="text/css">
.map-icon-label {
  color: #000;
  text-shadow:
    1px 1px 0 #fff,
    -1px -1px 0 #fff,
    -1px 1px 0 #fff,
    1px -1px 0 #fff,
    0px 1px 0 #fff,
    0-1px 0 #fff,
    -1px 0 0 #fff,
    1px 0 0 #fff;
}
.fullscreen::-webkit-scrollbar {
  /* Edge Chorome Safari Operaなど */
  display: none;
}
</style>
